<template>
    <div v-if="visible" :class="['alert', `alert-${variant}`, dismissible && 'alert-dismissible']" role="alert">
        <slot />
        <button v-if="dismissible" type="button" class="close" aria-label="Close" @click="dismiss"><span aria-hidden="true">&times;</span></button>
    </div>
</template>
<script>
import { emitModel } from "./model";
export default {
    name: "SbAlert",
    emits: ["dismissed", "update:modelValue"],
    props: {
        show: { type: Boolean, default: true },
        variant: { type: String, default: "info" },
        dismissible: { type: Boolean, default: false },
    },
    data() { return { locallyVisible: this.show }; },
    computed: { visible() { return this.locallyVisible && this.show; } },
    watch: { show(value) { this.locallyVisible = value; } },
    methods: {
        dismiss() {
            this.locallyVisible = false;
            emitModel(this, false);
            this.$emit("dismissed");
        },
    },
};
</script>
